export const FLASH_MESSAGE_TRANSITION = 250;
export const FLASH_MESSAGE_TTL = 5000;
export const FLASH_MESSAGE_ICONS = {
  success: 'check',
  danger: 'alert',
  warning: 'info',
};
